(ns renolit-roofing-service.layout.grid-table
  (:require
   [renolit-roofing-service.layout.form :as layout.form]
   [renolit-roofing-service.layout.grid-table.cell :as grid-table.cell]
   [renolit-roofing-service.layout.icon :as layout.icon]
   [renolit-roofing-service.layout.infinite-scroll :as layout.infinite-scroll]
   [renolit-roofing-service.localization :refer [t]]
   [renolit-roofing-service.util :as util]))

(defn- grid-clickable-row-indicator
  []
  [:div.grid-table__clickable-row-indicator
   [layout.icon/icon
    {:key "arrow_right_alt"}]])

(defn- grid-row
  [row-data
   {:keys [has-selectable-items row-href-fn
           cols on-row-click grid-row-extra-class
           subscription-parameters path]
    :as _opts}]
  (let [row-dom-type (cond
                       row-href-fn :a
                       :else :div)
        clickable? (or on-row-click row-href-fn)]
    [row-dom-type
     (cond-> {:class ["grid-table__row"]}

       grid-row-extra-class
       (update :class conj grid-row-extra-class)

       clickable?
       (update :class conj "grid-table__row--clickable")

       on-row-click
       (assoc :on-click #(util/execute-callback on-row-click row-data))

       (and row-href-fn (fn? row-href-fn))
       (assoc :href (row-href-fn row-data)))

     (when has-selectable-items
       [:div.grid-table__cell.grid-table__cell--checkbox
        {:on-click (fn [e]
                     (.preventDefault e)
                     (.stopPropagation e))}
        [layout.form/item
         {:type :checkbox
          :subscription-parameters subscription-parameters
          :path path
          :schema [:string]}]])
     (for [{:keys [id path cell-settings]} cols
           :let [cell-data (get-in row-data path)]]
       ^{:key id}
       [grid-table.cell/grid-table-cell cell-data cell-settings row-data
        (when clickable?
          [grid-clickable-row-indicator])])]))

(defn- grid-body-placeholder
  [{{:keys [msg-transl-kw action-btn]} :empty-placeholder}]
  [:div.grid-table__body-placeholder
   (when msg-transl-kw
     [:span.grid-table__body-placeholder-msg (t [msg-transl-kw])])
   (when action-btn
     (let [{:keys [title-transl-kw btn-icon-key class]} action-btn
           btn-title (t [title-transl-kw])]
       (if (:href action-btn)
         [:a.btn.btn--narrow
          (cond-> {:href (:href action-btn)
                   :class []}
            (:disabled? action-btn)
            (update :class conj "btn--disabled")

            class
            (update :class conj class))
          btn-title]
         [:button.btn.btn--narrow
          (cond-> {:on-click #(util/execute-callback action-btn [])
                   :class []}

            (:disabled? action-btn)
            (update :class conj "btn--disabled")

            class
            (update :class conj class))
          (when btn-icon-key
            [layout.icon/icon {:key btn-icon-key}])
          btn-title])))])

(defn- grid-body
  [{:keys [data pagination on-page-change id-fn] :as opts}]
  [:div.grid-table__body
   (for [row-data data]
     ^{:key (or (and id-fn (id-fn row-data))
                (:id row-data))}
     [grid-row row-data opts])
   (when on-page-change
     [layout.infinite-scroll/main pagination on-page-change])])

(defn header-checkbox [opts]
  [:div.grid-table__header-coll.grid-table__header-coll--checkbox
   [layout.form/item
    (merge opts {:type :checkbox
                 :schema [:string]})]])

(defn grid-header [{:keys [cols grid-header-extra-class has-selectable-items data] :as opts}]
  (when (seq data)
    [:div.grid-table__header {:class grid-header-extra-class}
     (when has-selectable-items [header-checkbox opts])
     (doall
      (for [{:keys [id title title-transl-kw header-class]} cols]
        ^{:key id}
        [:div.grid-table__header-coll
         {:class header-class}
         [:span (or title (t [title-transl-kw]))]]))]))

(defn main
  [{:keys [no-header? grid-table-extra-class data] :as opts}]
  [:div.grid-table
   {:class (cond-> []
             (string? grid-table-extra-class)
             (conj grid-table-extra-class)

             (coll? grid-table-extra-class)
             (concat grid-table-extra-class))}
   (when-not no-header?
     [grid-header opts])
   (if (empty? data)
     [grid-body-placeholder opts]
     [grid-body opts])])